import classNames from 'classnames';
import React from 'react';
import Ink from 'react-ink';
import './ListItem.scss';
import IListItemProps from './ListItemProps';

const ListItem = ({ onClick, ripple = true, disabled = false, className, children, clickable = true, ...divProps }: IListItemProps) => {
  const classes = classNames(
    'list-item',
    {
      'list-item-clickable': onClick && clickable,
      disabled,
    },
    className
  );

  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }

  return (
    <div className={classes} onClick={handleClick} {...divProps}>
      {children}
      {ripple && onClick && !disabled && <Ink background={false} />}
    </div>
  );
};

export default ListItem;
